import React from 'react';
import Layout from 'components/Layout';
import styled from 'styled-components';
import { useIntl, Link, FormattedMessage } from "gatsby-plugin-intl";
import {
    HeaderContainer,
    RelativeWrapperWithImage,
    MainSection,
} from 'components/pages/Integrations/styled';
import { WidthWrapper } from 'components/wrappers';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';
import { apiDocsLinks, apiDocsLinksChinese, apiDocsLinksKorean, apiDocsLinksJapanese } from 'components/Layout/navigation';
import Helmet from 'react-helmet';
import Joe from 'images/our-team/joe-zhang.png'
import {  HeaderSmall } from 'components/typography'; 
import ReasonDrivenIcon from 'pages/SocialMedia/why-us/images/reason_driven.png'
import ReasonFreeIcon from 'pages/SocialMedia/why-us/images/reason_free.png'
import ReasonGlobalIcon from 'pages/SocialMedia/why-us/images/reason_global.png'
import ReasonLowerIcon from 'pages/SocialMedia/why-us/images/reason_lower.png'
import ReasonMinimizeIcon from 'pages/SocialMedia/why-us/images/reason_minimize.png'
import ReasonMoneyIcon from 'pages/SocialMedia/why-us/images/reason_money.png'
import ReasonOnlineIcon from 'pages/SocialMedia/why-us/images/reason_online.png'
import SaveMoneyIcon from 'pages/SocialMedia/why-us/images/save_money_on_shipping.png'
import SaveTimeIcon from 'pages/SocialMedia/why-us/images/save-time.png'
import ShipkooIcon from 'pages/SocialMedia/why-us/images/shipkoo-icon.png'

const Wrapper = styled.div`
    padding-top: 100px;
    text-align: center;

    img {
        width: 100%;
        max-width: 100px;
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -50px 0 0 -50px;
    }
    .column {
        display: flex;
    }
    .card {
        width: 100%;
        height: 200px;
        box-shadow: 0px 0px 10px 0px #d3c8c8;
        margin: 13px;
        border-radius: 10px;
        padding: 10px;
        position: relative;
    }
`;

const Row = styled.div`
    max-width:1300px;
    align-items: center;
`;

const WhyUs = () => {
    const intl = useIntl()

    return (
        <WidthWrapper whiteMobile>
           <Wrapper>
                <div className="row">
                    <div className="column">
                        <div className="card">
                            <img src={ReasonDrivenIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                        <div className="card">
                            <img src={ReasonFreeIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                        <div className="card">
                            <img src={ReasonGlobalIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="column">
                        <div className="card">
                            <img src={ReasonOnlineIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                        <div className="card">
                            <img src={SaveMoneyIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                        <div className="card">
                            <img src={ShipkooIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="column">
                        <div className="card">
                            <img src={ReasonLowerIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                        <div className="card">
                            <img src={ReasonMinimizeIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                        <div className="card">
                            <img src={ReasonLowerIcon} />
                            <p>
                                {intl.formatMessage({ id: "image-title-social" })}
                            </p>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </WidthWrapper>
    );
};

export default WhyUs;